/**
 * Route definitions for the print assets section (files list,
 * file detail, and filter drawer).
 * Mirrors the pattern in views/admin/billing/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { featureFlags } from "../../featureFlags";
import { withHandle } from "../../utils/route.util";
import { PrintAssetsView } from "./PrintAssetsView";
import { PrintAssetView } from "./PrintAssetView";
import { PrintAssetsFilterInner, path as printAssetsFilterPath } from "./PrintAssetsFilter";

export const printAssetsFilterRoute: RouteObject = {
  path: printAssetsFilterPath,
  element: <PrintAssetsFilterInner />,
};

export const printAssetsRoutes: RouteObject[] = [
  {
    path: "print-assets",
    element: <PrintAssetsView />,
    ...withHandle("print-assets"),
    children: [...(featureFlags.newSearchExperience ? [printAssetsFilterRoute] : [])],
  },
  {
    path: "print-assets/:id",
    element: <PrintAssetView />,
    ...withHandle("print-asset-detail"),
  },
];
